export default "__VITE_ASSET__BMLZzx9l__";